import React, { useState } from 'react';
import { useFormBuilder } from '../utils/useFormBuilder';
import { useWorkOrderSchedule } from '../hook/useWorkOrderSchedule';
import { useWorkOrderScheduleFields } from '../hook/useWorkOrderScheduleFields';

const WorkOrderMakeRecurringModal = ({ show, onClose, workOrder, onSaved }) => {
  const { createSchedule } = useWorkOrderSchedule();
  const [formData, setFormData] = useState({
    active: 1,
    recurrencePattern: 'weekly',
    startDate: workOrder?.scheduledAt || new Date().toISOString(),
    noEndDate: 1,
    dayOfMonth: 1,
    monthOfYear: 1,
  });
  const [errors] = useState({});

  const scheduleFields = useWorkOrderScheduleFields({
    workOrderSchedule: formData,
    setWorkOrderSchedule: setFormData,
    includeActive: false,
  });

  const { renderField } = useFormBuilder(scheduleFields, formData, setFormData, errors);

  const handleSave = async () => {
    if (!workOrder) return;
    const payload = {
      templateWorkOrderId: workOrder.id,
      recurrencePattern: formData.recurrencePattern,
      intervalValue: parseInt(formData.intervalValue, 10) || 0,
      daysOfWeek: formData.daysOfWeek || null,
      dayOfMonth: parseInt(formData.dayOfMonth, 10) || 1,
      monthOfYear: formData.monthOfYear ? parseInt(formData.monthOfYear, 10) : null,
      startDate: formData.startDate ? new Date(formData.startDate).toISOString() : null,
      endDate: formData.endDate ? new Date(formData.endDate).toISOString() : null,
      occurrenceCount: formData.occurrenceCount != null ? parseInt(formData.occurrenceCount, 10) : null,
      noEndDate: !!formData.noEndDate,
      active: 1,
    };
    try {
      const saved = await createSchedule(payload);
      if (saved?.id && typeof onSaved === 'function') {
        onSaved(saved.id);
      }
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  if (!show) return null;

  return (
    <div className="modal modal-xl modal-backdrop show d-block" tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Make Recurring Work Order</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>
          <div className="modal-body">
            <div className="row g-3">{scheduleFields.map(renderField)}</div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
            <button className="btn btn-primary" onClick={handleSave}>Save</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkOrderMakeRecurringModal;

